import IOMessage from '../../native-types/IOMessage';
import { defineMessages } from 'react-intl';
import { seller } from '../../mock';
import { useCssHandles } from '../../../utils/functions';

const LINK_SELLER_HANDLES = ['linkSellerContainer', 'linkSeller', 'linkSellerText', 'linkSellerNumber'] as const;

interface Props {
	message?: string;
	componentId?: string;
	blockClass?: string;
}

function LinkSeller({ message, componentId, blockClass }: Props) {
	const { handles }: any = useCssHandles(`vtex-seller-selector-0-x`, LINK_SELLER_HANDLES, blockClass);

	const availableSellers = [seller];

	if (!availableSellers || availableSellers.length <= 1) {
		return null;
	}

	return (
		<div data-selection={componentId} className={`${handles.linkSellerContainer} flex flex-row-reverse relative`}>
			<a className={`${handles.linkSeller}`}>
				<p className={`${handles.linkSellerText} pr6`}>
					<IOMessage
						id={message}
						values={{
							sellerQuantity: availableSellers.length,
						}}
					/>
				</p>
			</a>
		</div>
	);
}

const messages = defineMessages({
	title: {
		id: 'admin/editor.seller-link.title',
	},
});

LinkSeller.schema = {
	title: messages.title.id,
};

export default LinkSeller;
